<template>

    <Grid>

        <Column :span="[ 2, 3 ]">

            <AOS type="fade-up" duration="800" delay="1000">

                <Heading tag="h2" v-html="heading"/>

            </AOS>

        </Column>

        <AOS type="fade-up" duration="800" delay="1000">

            <Column :span="[ 2, 3 ]">

                <Button :route="route" class="contact-header__button sm:mt-12">
                    {{ label }}
                </Button>

            </Column>

        </AOS>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent, PropType } from 'vue'
    import { RouteLocation } from 'vue-router'
    import Grid from './Grid/Grid.vue'
    import Column from './Grid/Column.vue'
    import Button from './Button.vue'
    import Heading from './Heading.vue'

    export default defineComponent({
        name: 'ContactHeader',
        props: {
            heading: { type: String, required: true },
            route: { type: [ Object, String ] as PropType<RouteLocation | string>, required: false },
            label: { type: String, required: true }
        },
        components: {
            Grid,
            Column,
            Button,
            Heading
        }
    })

</script>

<style lang="scss">

    @include component(contact-header) {

        @include part(button) {

            @screen md {

                transform: translateY(7px);

            }

        }

    }

</style>
